import React from "react";
import { Box } from "@material-ui/core";
import { CorporateReferralBanner, useDeviceTypes } from "halifax";
import {
  SessionInfo,
  CorpSessionInfo,
  CorporateReferralBannerSource,
  Funnel,
  RewardsAccount,
} from "redmond";
import {
  SpendAndGetOfferHomePageSection,
  SpendAndGetCelebrationBanner,
  useSetActiveBusinessAccount,
} from "@capone-corporate/portal";
import { isCorpTenant } from "@capone/common";
import { config } from "../../../api/config";
import {
  useExperiments,
  getExperimentVariant,
  CORP_SPEND_AND_GET_OFFER,
  AVAILABLE,
} from "../../../context/experiments";
import clsx from "clsx";
import "./styles.scss";

interface CorpHomePageTopSectionProps {
  sessionInfo: SessionInfo | CorpSessionInfo;
  accounts?: RewardsAccount[];
  selectedAccountReferenceId?: string | null;
  funnel?: Funnel;
  trackEvent: (event: {
    eventName: string;
    properties: Record<string, unknown>;
  }) => void;
}

export const CorpHomePageTopSection = ({
  sessionInfo,
  accounts,
  selectedAccountReferenceId,
  funnel,
  trackEvent,
}: CorpHomePageTopSectionProps) => {
  if (!isCorpTenant(config.TENANT)) return null;

  const expState = useExperiments();
  const { matchesMobile } = useDeviceTypes();
  useSetActiveBusinessAccount();
  const isSpendAndGetOfferEnabled =
    getExperimentVariant(expState.experiments, CORP_SPEND_AND_GET_OFFER) ===
    AVAILABLE;

  return (
    <Box>
      {isSpendAndGetOfferEnabled && (
        <SpendAndGetOfferHomePageSection
          className={clsx("corp-spend-and-get-homepage-section", {
            mobile: matchesMobile,
          })}
        />
      )}
      <CorporateReferralBanner
        sessionInfo={sessionInfo}
        source={CorporateReferralBannerSource.Homepage}
        trackEvent={trackEvent}
        funnel={funnel}
        accounts={accounts}
        activeUserBusinessId={selectedAccountReferenceId}
      />
      {isSpendAndGetOfferEnabled && <SpendAndGetCelebrationBanner />}
    </Box>
  );
};
